import { TextField, Stack, Box } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { bookContextService } from 'src/Services/ApiHandlers/bookContext';
import { toast } from 'react-toastify';
import BookContextList from './BookContextList';
import { LoadingButton } from '@mui/lab';

const BookContext = ({ content_id }) => {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [contexts, setContexts] = useState([]);

  const fetchContexts = useCallback(() => {
    bookContextService.getContext(content_id).then((response) => {
      setContexts(response.data);
    });
  }, []);

  useEffect(() => {
    fetchContexts();
  }, [fetchContexts]);

  const deleteHandler = (contextId) => {
    bookContextService.deleteContext(contextId).then((response) => {
      toast.success('Context deleted successfully');
      fetchContexts();
    });
  };

  const uploadHandler = () => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append('file', file);
      formData.append('content_id', content_id);
      bookContextService.create(formData).then((response) => {
        toast.success('Context uploaded successfully');
        fetchContexts();
      });
    } catch (error) {
      toast.error('Error uploading context');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Stack
      direction="column"
      sx={{
        minHeight: '400px',
      }}
    >
      <Box
        spacing={2}
        sx={{
          alignItems: 'center',
          borderBottom: '1px solid #e0e0e0',
          display: 'flex',
          flexDirection: {
            xs: 'column',
            md: 'row',
          },
          gap: 2,
          pb: 2,
        }}
      >
        <TextField
          sx={{
            mb: '1rem',
            width: {
              xs: '100%',
              lg: '350px',
            },
          }}
          type="file"
          onChange={(e) => {
            setFile(e.target.files[0]);
          }}
        />
        <LoadingButton
          variant="contained"
          color="primary"
          sx={{
            height: '100%',
          }}
          onClick={uploadHandler}
          loading={loading}
        >
          Upload
        </LoadingButton>
      </Box>
      <BookContextList contexts={contexts} deleteHandler={deleteHandler} />
    </Stack>
  );
};

export default BookContext;
